






import { mapState } from 'vuex'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  computed: {
    ...mapState(CLASSIFIED_FORM_NS, {
      topAlert: state => state.topAlert
    })
  }
})
